import { useMutation, useQueryClient } from 'react-query';

import { Report } from '../../../types/Report';
import Api from '../../api/api';

export const reinstateUser = async (reportedUserId: string) => {
  const [response, bodyOrError] = await Api.patch(`reports/${reportedUserId}/reinstate-reported-user`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useReinstateReportedUser = () => {
  const queryClient = useQueryClient();

  return useMutation<Report, Error, string>('reinstateUser', reinstateUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('reportedUsers');
    },
  });
};
